<template>
  <div class="inside-modal">
    <!-- ============= Logo / title =============  -->
    <div class="row f-row text-center">
      <div class="col col-12 mt-3">
        <img
          :src="logo"
          @mouseover="logo = logo_blue"
          @mouseout="logo = logo_white"
          height="30"
          alt=""
          style="padding: 0"
        />
      </div>
    </div>
    <div
      class="row f-row text-center"
      style="border-bottom: 1px solid var(--graylightbackground) !important;"
    >
      <div class="col col-12 mt-1 mb-2">
        {{ createEditTextHedge }}
      </div>
    </div>
    <!-- ============= form =============  -->
    <div class="row f-row mt-3">
      <div class="col col-1"></div>
      <div class="col col-10">
        <form @submit.prevent="validateBeforeSubmit">
          <!-- https://logaretm.github.io/vee-validate/guide/basics.html#validation-provider -->
          <!-- ============= required fields =============  -->
          Required fields:<br />
          <table
            class="table table-sm table-responsive table-borderless table-data-controls my-data-table"
            style="width: 100%;"
          >
            <tbody>
              <tr>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('fk_idportafolio')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Portfolio
                  </label>
                  <input
                    v-validate="'required|max:150'"
                    class="custom-input-2"
                    name="fk_idportafolio"
                    placeholder="Name"
                    v-model="newEditedItemHedge.fk_idportafolio"
                    :class="{
                      input: true,
                      'is-danger': errors.has('fk_idportafolio'),
                    }"
                    type="text"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">Rate</label>
                  <select
                    class="dropdown-form dropdown-sm"
                    v-model="newEditedItemHedge.fk_idcurrency"
                    @change="onCrudHedgeCurrency"
                  >
                    <option
                      v-for="currency in allCurrencies"
                      v-bind:value="currency.currency_name"
                      :key="currency.id"
                      >{{ currency.currency_name.toUpperCase() }}</option
                    >
                  </select>
                </td>
                <td class="my-data-td">
                  <label class="txt-label">Long|Short</label>
                  <select
                    class="dropdown-form dropdown-sm"
                    v-model="newEditedItemHedge.buy_sell"
                  >
                    <option>LONG</option>
                    <option>SHORT</option>
                    <option>OFFSET LONG</option>
                    <option>OFFSET SHORT</option>
                  </select>
                </td>
                <td class="my-data-td">
                  <label class="txt-label"
                    >Derivative (on {{ leftRightCurrHedge[0] }})</label
                  >
                  <select
                    class="dropdown-form dropdown-sm"
                    v-model="newEditedItemHedge.derivative"
                  >
                    <option>FUTURE</option>
                    <option>FORWARD</option>
                    <option>CALL</option>
                    <option>PUT</option>
                  </select>
                </td>
                <td class="my-data-td">
                  <label class="txt-label">Derivative Type</label>
                  <select
                    class="dropdown-form dropdown-sm"
                    v-model="newEditedItemHedge.fk_idoptiontype"
                  >
                    <option
                      v-for="type in optionTypes"
                      v-bind:value="type.name"
                      :key="type.id"
                      >{{ type.name.toUpperCase() }}</option
                    >
                  </select>
                </td>
                <td class="my-data-td">
                  <label class="txt-label">Settlement Type</label>
                  <select
                    class="dropdown-form dropdown-sm"
                    v-model="newEditedItemHedge.settlement_type"
                  >
                    <option></option>
                    <option>DELIVERABLE</option>
                    <option>NON DELIVERABLE</option>
                  </select>
                </td>
              </tr>
              <tr>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('trade_date')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Trade Date
                  </label>
                  <input
                    v-validate="'required|date_format:yyyy-MM-dd'"
                    style="height: 19px!important;"
                    type="date"
                    class="custom-input-2"
                    name="trade_date"
                    placeholder="yyyy-mm-dd"
                    v-model="newEditedItemHedge.trade_date"
                    :class="{
                      input: true,
                      'is-danger': errors.has('trade_date'),
                    }"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="
                        errors.has('fixing_date') ||
                          fixingValueDistance > 0 ||
                          fixingValueDistance < -15
                      "
                      class="fa fa-warning warn-my-data"
                    ></i>
                    {{ asianText }}
                  </label>
                  <input
                    v-validate="'required|date_format:yyyy-MM-dd'"
                    style="height: 19px!important;"
                    type="date"
                    class="custom-input-2"
                    name="fixing_date"
                    placeholder="yyyy-mm-dd"
                    v-model="newEditedItemHedge.fixing_date"
                    :class="{
                      input: true,
                      'is-danger': errors.has('fixing_date'),
                    }"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="
                        errors.has('value_date') ||
                          fixingValueDistance > 0 ||
                          fixingValueDistance < -15
                      "
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Value Date
                  </label>
                  <input
                    v-validate="'required|date_format:yyyy-MM-dd'"
                    style="height: 19px!important;"
                    type="date"
                    class="custom-input-2"
                    name="value_date"
                    placeholder="yyyy-mm-dd"
                    v-model="newEditedItemHedge.value_date"
                    :class="{
                      input: true,
                      'is-danger': errors.has('value_date'),
                    }"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('strike')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Strike
                    <span style="color: var(--textactive)">
                      ({{ leftRightCurrHedge[0] }}/{{ leftRightCurrHedge[1] }})
                    </span>
                  </label>
                  <input
                    v-validate="'required|min_value:0|decimal:18'"
                    class="custom-input-2"
                    name="strike"
                    placeholder="Rate"
                    v-model="newEditedItemHedge.strike"
                    :class="{
                      input: true,
                      'is-danger': errors.has('strike'),
                    }"
                    type="number"
                    step="0.000000000000000001"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('notional')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Notional
                  </label>
                  <InputNumber
                    style="height: 19px!important;"
                    :tableFormat="false"
                    :value="+newEditedItemHedge.notional"
                    @input="(val) => onUserNotionalChange(val)"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">Notional Currency</label>
                  <select
                    class="dropdown-form dropdown-sm"
                    v-model="newEditedItemHedge.fk_idcountry_currency"
                  >
                    <option
                      v-for="currency in leftRightCurrHedge"
                      v-bind:value="currency"
                      :key="currency.id"
                      >{{ currency.toUpperCase() }}</option
                    >
                  </select>
                </td>
              </tr>
              <tr>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('premium')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Premium
                  </label>
                  <InputNumber
                    style="height: 19px!important;"
                    :tableFormat="false"
                    :value="+newEditedItemHedge.premium"
                    @input="(val) => onUserPremiumChange(val)"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">Premium Currency</label>
                  <select
                    class="dropdown-form dropdown-sm"
                    v-model="newEditedItemHedge.fk_idcountry_premium_currency"
                  >
                    <option
                      v-for="currency in leftRightCurrHedge"
                      v-bind:value="currency"
                      :key="currency.id"
                      >{{ currency.toUpperCase() }}</option
                    >
                  </select>
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('premium_value_date')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Premium Value Date
                  </label>
                  <input
                    v-validate="'required|date_format:yyyy-MM-dd'"
                    style="height: 19px!important;"
                    type="date"
                    class="custom-input-2"
                    name="premium_value_date"
                    placeholder="yyyy-mm-dd"
                    v-model="newEditedItemHedge.premium_value_date"
                    :class="{
                      input: true,
                      'is-danger': errors.has('premium_value_date'),
                    }"
                  />
                </td>
                <td class="my-data-td" v-if="barrier1CRUD">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('barrier')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Barrier
                  </label>
                  <input
                    v-validate="'required|min_value:0|decimal:18'"
                    class="custom-input-2"
                    name="barrier"
                    placeholder="Rate"
                    v-model="newEditedItemHedge.barrier"
                    :class="{
                      input: true,
                      'is-danger': errors.has('barrier'),
                    }"
                    type="number"
                    step="0.000000000000000001"
                  />
                </td>
                <td class="my-data-td" v-if="barrier2CRUD">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('barrier_2')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Second Barrier
                  </label>
                  <input
                    v-validate="'required|min_value:0|decimal:18'"
                    class="custom-input-2"
                    name="barrier_2"
                    placeholder="Rate"
                    v-model="newEditedItemHedge.barrier_2"
                    :class="{
                      input: true,
                      'is-danger': errors.has('barrier_2'),
                    }"
                    type="number"
                    step="0.000000000000000001"
                  />
                </td>
                <td class="my-data-td" v-if="asianCRUD">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('asian_fixing_start_date')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Asian Initial Fixing Date
                  </label>
                  <input
                    v-validate="'required|date_format:yyyy-MM-dd'"
                    style="height: 19px!important;"
                    type="date"
                    class="custom-input-2"
                    name="asian_fixing_start_date"
                    placeholder="yyyy-mm-dd"
                    v-model="newEditedItemHedge.asian_fixing_start_date"
                    :class="{
                      input: true,
                      'is-danger': errors.has('asian_fixing_start_date'),
                    }"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <br />

          <!-- ============= optional fields =============  -->
          Optional fields:<br />
          <table
            class="my-data-table table table-sm table-responsive table-borderless table-data-controls"
            style="width: 100%;"
          >
            <tbody>
              <tr>
                <td class="my-data-td" colspan="2">
                  <label class="txt-label" style="display:block"
                    >Strategy</label
                  >
                  <select
                    class="dropdown-form dropdown-form-25 dropdown-sm"
                    v-model="newEditedItemHedge.strategy_position"
                  >
                    <option></option>
                    <option>LONG</option>
                    <option>SHORT</option>
                  </select>
                  <select
                    class="dropdown-form dropdown-form-75 dropdown-sm"
                    v-model="newEditedItemHedge.strategy_name"
                  >
                    <option
                      v-for="(strategy, idx) in strategies.filter(
                        (d) =>
                          d.strategy_position.toUpperCase() ===
                          newEditedItemHedge.strategy_position,
                      )"
                      :key="idx"
                      >{{ strategy.fk_idstrategyname }}</option
                    >
                  </select>
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('strategy_code')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Strategy Code
                  </label>
                  <input
                    v-validate="'max:150'"
                    class="custom-input-2"
                    name="strategy_code"
                    placeholder="Code"
                    v-model="newEditedItemHedge.strategy_code"
                    :class="{
                      input: true,
                      'is-danger': errors.has('strategy_code'),
                    }"
                    type="text"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('spot_reference')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Spot Reference
                    <span style="color: var(--textactive)">
                      ({{ leftRightCurrHedge[0] }}/{{ leftRightCurrHedge[1] }})
                    </span>
                  </label>
                  <input
                    v-validate="'min_value:0|decimal:18'"
                    class="custom-input-2"
                    name="spot_reference"
                    placeholder="Rate"
                    v-model="newEditedItemHedge.spot_reference"
                    :class="{
                      input: true,
                      'is-danger': errors.has('spot_reference'),
                    }"
                    type="number"
                    step="0.000000000000000001"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('hedged_date')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Hedged Date
                  </label>
                  <input
                    v-validate="'date_format:yyyy-MM-dd'"
                    type="date"
                    class="custom-input-2"
                    name="hedged_date"
                    placeholder="yyyy-mm-dd"
                    v-model="newEditedItemHedge.hedged_date"
                    :class="{
                      input: true,
                      'is-danger': errors.has('hedged_date'),
                    }"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('sale_date')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Exposure End Date
                  </label>
                  <input
                    v-validate="'date_format:yyyy-MM-dd'"
                    type="date"
                    class="custom-input-2"
                    name="sale_date"
                    placeholder="yyyy-mm-dd"
                    v-model="newEditedItemHedge.sale_date"
                    :class="{
                      input: true,
                      'is-danger': errors.has('sale_date'),
                    }"
                  />
                </td>
              </tr>
              <tr>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('shipping_date')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Shipping Date
                  </label>
                  <input
                    v-validate="'date_format:yyyy-MM-dd'"
                    type="date"
                    class="custom-input-2"
                    name="shipping_date"
                    placeholder="yyyy-mm-dd"
                    v-model="newEditedItemHedge.shipping_date"
                    :class="{
                      input: true,
                      'is-danger': errors.has('shipping_date'),
                    }"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('hedge_asset')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Hedged Asset
                  </label>
                  <input
                    v-validate="'max:150'"
                    class="custom-input-2"
                    name="hedge_asset"
                    placeholder="Asset"
                    v-model="newEditedItemHedge.hedge_asset"
                    :class="{
                      input: true,
                      'is-danger': errors.has('hedge_asset'),
                    }"
                    type="text"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('end_product')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    End Product Hedged
                  </label>
                  <input
                    v-validate="'max:150'"
                    class="custom-input-2"
                    name="end_product"
                    placeholder="Product"
                    v-model="newEditedItemHedge.end_product"
                    :class="{
                      input: true,
                      'is-danger': errors.has('end_product'),
                    }"
                    type="text"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('custom_strategy_name')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Custom Hedge Name
                  </label>
                  <input
                    v-validate="'max:150'"
                    class="custom-input-2"
                    name="custom_strategy_name"
                    placeholder="Custom Hedge Name"
                    v-model="newEditedItemHedge.custom_strategy_name"
                    :class="{
                      input: true,
                      'is-danger': errors.has('custom_strategy_name'),
                    }"
                    type="text"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('counterpartys_id')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Custom Id
                  </label>
                  <input
                    v-validate="'max:150'"
                    class="custom-input-2"
                    name="counterpartys_id"
                    placeholder="Name"
                    v-model="newEditedItemHedge.counterpartys_id"
                    :class="{
                      input: true,
                      'is-danger': errors.has('counterpartys_id'),
                    }"
                    type="text"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('counterparty')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Counterparty
                  </label>
                  <input
                    v-validate="'max:150'"
                    class="custom-input-2"
                    name="counterparty"
                    placeholder="Counterparty Name"
                    v-model="newEditedItemHedge.counterparty"
                    :class="{
                      input: true,
                      'is-danger': errors.has('counterparty'),
                    }"
                    type="text"
                  />
                </td>
              </tr>
              <tr>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('provider')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Provider Name
                  </label>
                  <input
                    v-validate="'max:150'"
                    class="custom-input-2"
                    name="provider"
                    placeholder="Provider Name"
                    v-model="newEditedItemHedge.provider"
                    :class="{
                      input: true,
                      'is-danger': errors.has('provider'),
                    }"
                    type="text"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('client')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Client Name
                  </label>
                  <input
                    v-validate="'max:150'"
                    class="custom-input-2"
                    name="client"
                    placeholder="Client Name"
                    v-model="newEditedItemHedge.client"
                    :class="{
                      input: true,
                      'is-danger': errors.has('client'),
                    }"
                    type="text"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('plant')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Plant Supplied/Production
                  </label>
                  <input
                    v-validate="'max:150'"
                    class="custom-input-2"
                    name="plant"
                    placeholder="Plant Name"
                    v-model="newEditedItemHedge.plant"
                    :class="{
                      input: true,
                      'is-danger': errors.has('plant'),
                    }"
                    type="text"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('comments')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Comments
                  </label>
                  <input
                    v-validate="'max:150'"
                    class="custom-input-2"
                    name="Comments"
                    placeholder="Comments"
                    v-model="newEditedItemHedge.comments"
                    :class="{
                      input: true,
                      'is-danger': errors.has('comments'),
                    }"
                    type="text"
                  />
                </td>
                <td class="my-data-td" v-show="auxDate < today">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('settlement_rate')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Settlement Rate
                    <span style="color: var(--textactive)">
                      ({{ leftRightCurrHedge[0] }}/{{ leftRightCurrHedge[1] }})
                    </span>
                  </label>
                  <input
                    v-validate="'min_value:0|decimal:18'"
                    class="custom-input-2"
                    name="settlement_rate"
                    placeholder="Rate"
                    v-model="newEditedItemHedge.settlement_rate"
                    :class="{
                      input: true,
                      'is-danger': errors.has('settlement_rate'),
                    }"
                    type="number"
                    step="0.000000000000000001"
                  />
                </td>
                <td class="my-data-td" v-show="auxDate < today">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('settlement_pnl')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Settlement Cash Flow
                    <span style="color: var(--textactive)">
                      ({{ leftRightCurrHedge[1] }})
                    </span>
                  </label>
                  <input
                    v-validate="'decimal:18'"
                    class="custom-input-2"
                    name="settlement_pnl"
                    placeholder="Profit or Loss"
                    v-model="newEditedItemHedge.settlement_pnl"
                    :class="{
                      input: true,
                      'is-danger': errors.has('settlement_pnl'),
                    }"
                    type="number"
                    step="0.000000000000000001"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <!-- ============= Buttons =============  -->
          <div class="row f-row">
            <div
              class="col col-6 text-right align-right"
              style="padding-right: 5px;"
            >
              <button class="btn btn-sm btn-home" v-on:click="onUserCancel">
                Cancel
              </button>
            </div>
            <div
              class="col col-6 text-left align-left"
              style="padding-left: 5px;"
            >
              <button class="btn btn-sm btn-home">
                Accept
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <!-- ============= Show Errors =============  -->
    <div class="row f-row mt-3">
      <div class="col col-1"></div>
      <div class="col col-10 btn-warn">
        <span v-show="errors.has('fk_idportafolio')"
          >{{ errors.first("fk_idportafolio") }}.<br
        /></span>
        <span v-show="errors.has('fk_idcurrency')"
          >{{ errors.first("fk_idcurrency") }}.<br
        /></span>
        <span v-show="errors.has('derivative')"
          >{{ errors.first("derivative") }}.<br
        /></span>
        <span v-show="errors.has('fk_idoptiontype')"
          >{{ errors.first("fk_idoptiontype") }}.<br
        /></span>
        <span v-show="errors.has('settlement_type')"
          >{{ errors.first("settlement_type") }}.<br
        /></span>
        <span v-show="errors.has('trade_date')"
          >{{ errors.first("trade_date") }}.<br
        /></span>
        <span v-show="errors.has('fixing_date')"
          >{{ errors.first("fixing_date") }}.<br
        /></span>
        <span v-show="fixingValueDistance > 0"
          >Value Date &#8805; Fixing Date.<br
        /></span>
        <span v-show="fixingValueDistance < -15"
          >Value Date should be less than 15 days after Fixing Date.<br
        /></span>
        <span v-show="asian_fixing_start_date < fixing_date"
          >Fixing date must be later than asian start date<br
        /></span>
        <span v-show="errors.has('value_date')"
          >{{ errors.first("value_date") }}.<br
        /></span>
        <span v-show="errors.has('strike')"
          >{{ errors.first("strike") }}.<br
        /></span>
        <span v-show="errors.has('notional')"
          >{{ errors.first("notional") }}.<br
        /></span>
        <span v-show="errors.has('fk_idcountry_currency')"
          >{{ errors.first("fk_idcountry_currency") }}.<br
        /></span>
        <span v-show="errors.has('premium')"
          >{{ errors.first("premium") }}.<br
        /></span>
        <span v-show="errors.has('fk_idcountry_premium_currency')"
          >{{ errors.first("fk_idcountry_premium_currency") }}.<br
        /></span>
        <span v-show="errors.has('premium_value_date')"
          >{{ errors.first("premium_value_date") }}.<br
        /></span>
        <span v-show="errors.has('barrier')"
          >{{ errors.first("barrier") }}.<br
        /></span>
        <span v-show="errors.has('barrier_2')"
          >{{ errors.first("barrier_2") }}.<br
        /></span>
        <span v-show="errors.has('asian_fixing_start_date')"
          >{{ errors.first("asian_fixing_start_date") }}.<br
        /></span>
        <span v-show="errors.has('fk_idcurrencystrategy_derivative')"
          >{{ errors.first("fk_idcurrencystrategy_derivative") }}.<br
        /></span>
        <span v-show="errors.has('strategy_code')"
          >{{ errors.first("strategy_code") }}.<br
        /></span>
        <span v-show="errors.has('spot_reference')"
          >{{ errors.first("spot_reference") }}.<br
        /></span>
        <span v-show="errors.has('hedge_asset')"
          >{{ errors.first("hedge_asset") }}.<br
        /></span>
        <span v-show="errors.has('end_product')"
          >{{ errors.first("end_product") }}.<br
        /></span>
        <span v-show="errors.has('custom_strategy_name')"
          >{{ errors.first("custom_strategy_name") }}.<br
        /></span>
        <span v-show="errors.has('counterpartys_id')"
          >{{ errors.first("counterpartys_id") }}.<br
        /></span>
        <span v-show="errors.has('counterparty')"
          >{{ errors.first("counterparty") }}.<br
        /></span>
        <span v-show="errors.has('provider')"
          >{{ errors.first("provider") }}.<br
        /></span>
        <span v-show="errors.has('client')"
          >{{ errors.first("client") }}.<br
        /></span>
        <span v-show="errors.has('plant')"
          >{{ errors.first("plant") }}.<br
        /></span>
        <span v-show="errors.has('Comments')"
          >{{ errors.first("comments") }}.<br
        /></span>
        <span v-show="errors.has('custom_strategy_name')"
          >{{ errors.first("custom_strategy_name") }}.<br
        /></span>
        <span v-show="errors.has('settlement_rate')"
          >{{ errors.first("settlement_rate") }}.<br
        /></span>
        <span v-show="errors.has('settlement_pnl')"
          >{{ errors.first("settlement_pnl") }}.<br
        /></span>
      </div>
    </div>
  </div>
</template>

<script>
import { timeParse } from "d3";
import InputNumber from "@/components/InputNumber";
import { prepDate } from "@/_core/_helpers/_helpers";

export default {
  name: "NewEditHedgeCurrencies",
  props: {
    allCurrencies: { required: true },
    colorTheme: { required: true, type: Boolean, default: true },
    createEditTextHedge: { required: true },
    editedItemHedge: { required: true },
    optionTypes: { required: true },
    strategies: { required: true },
  },
  components: {
    InputNumber,
  },
  data() {
    return {
      today: new Date(),
      date:
        new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1) +
        "-" +
        new Date().getDate(),
      logo_white: require("@/assets/images/QuanspireLogoWhite.svg"),
      logo_blue: require("@/assets/images/QuanspireLogoBlue.svg"),
      logo: require("@/assets/images/QuanspireLogoWhite.svg"),
      asianText: "Fixing Date",
      leftRightCurrHedge: "USD",
      newEditedItemHedge: {
        pk: "pending",
        edited: false,
        fk_idportfolio: "",
        fk_idcurrency: "EURUSD",
        trade_date: new Date().toLocaleString(),
        fixing_date: new Date().toLocaleString(),
        value_date: new Date().toLocaleString(),
        derivative: "CALL",
        fk_idoptiontype: "EUROPEAN",
        buy_sell: "LONG",
        strike: "1",
        notional: "100000",
        fk_idcountry_currency: "USD",
        premium: "0",
        fk_idcountry_premium_currency: "EUR",
        premium_value_date: new Date().toLocaleString(),
        settlement_rate: "",
        settlement_pnl: "",
        fk_idcurrencystrategy_derivative: "LONG CALL",
        strategy_name: "CALL",
        strategy_position: "LONG",
        strategy_code: "",
        settlement_type: "NON DELIVERABLE",
        counterparty: "",
        custom_strategy_name: "",
        spot_reference: "",
        barrier: "",
        barrier_2: "",
        asian_fixing_start_date: new Date().toLocaleString(),
      },
    };
  },
  created() {
    this.createNewEdited();
  },
  mounted() {
    if (this.colorTheme) {
      this.logo_white = require("@/assets/images/QuanspireLogoWhite.svg");
      this.logo = require("@/assets/images/QuanspireLogoWhite.svg");
    } else if (!this.colorTheme) {
      this.logo_white = require("@/assets/images/QuanspireLogoBlack.svg");
      this.logo = require("@/assets/images/QuanspireLogoBlack.svg");
    }
  },
  watch: {
    colorTheme() {
      if (this.colorTheme) {
        this.logo_white = require("@/assets/images/QuanspireLogoWhite.svg");
        this.logo = require("@/assets/images/QuanspireLogoWhite.svg");
      } else if (!this.colorTheme) {
        this.logo_white = require("@/assets/images/QuanspireLogoBlack.svg");
        this.logo = require("@/assets/images/QuanspireLogoBlack.svg");
      }
    },
    editedItemHedge() {
      this.createNewEdited();
    },
    asianCRUD() {
      if (this.asianCRUD) {
        this.asianText = "Final Fixing Date";
      } else {
        this.asianText = "Fixing Date";
      }
    },
    strategyLong(val) {
      this.newEditedItemHedge.fk_idcurrencystrategy_derivative = val;
    },
  },
  computed: {
    strategyLong() {
      return (
        this.newEditedItemHedge.strategy_position +
        " " +
        this.newEditedItemHedge.strategy_name
      );
    },
    auxDate() {
      return timeParse("%Y-%m-%d")(this.newEditedItemHedge.fixing_date);
    },
    fixingValueDistance() {
      return (
        (timeParse("%Y-%m-%d")(this.newEditedItemHedge.fixing_date) -
          timeParse("%Y-%m-%d")(this.newEditedItemHedge.value_date)) /
        (1000 * 60 * 60 * 24)
      );
    },
    barrier1CRUD() {
      return (
        [
          "UP AND IN",
          "UP AND OUT",
          "DOWN AND IN",
          "DOWN AND OUT",
          "DOUBLE KNOCK IN",
          "DOUBLE KNOCK OUT",
        ].indexOf(this.newEditedItemHedge.fk_idoptiontype) > -1
      );
    },
    barrier2CRUD() {
      return (
        ["DOUBLE KNOCK IN", "DOUBLE KNOCK OUT"].indexOf(
          this.newEditedItemHedge.fk_idoptiontype,
        ) > -1
      );
    },
    asianCRUD() {
      return ["ASIAN"].indexOf(this.newEditedItemHedge.fk_idoptiontype) > -1;
    },
  },
  methods: {
    createNewEdited() {
      this.newEditedItemHedge = JSON.parse(
        JSON.stringify(this.editedItemHedge),
      );
      this.leftRightCurrHedge = [
        this.newEditedItemHedge.fk_idcurrency.slice(0, 3),
        this.newEditedItemHedge.fk_idcurrency.slice(3, 6),
      ];
      // Dates
      this.newEditedItemHedge.trade_date = prepDate(
        this.newEditedItemHedge.trade_date,
      );
      this.newEditedItemHedge.fixing_date = prepDate(
        this.newEditedItemHedge.fixing_date,
      );
      this.newEditedItemHedge.value_date = prepDate(
        this.newEditedItemHedge.value_date,
      );
      this.newEditedItemHedge.premium_value_date = prepDate(
        this.newEditedItemHedge.premium_value_date,
      );
      this.newEditedItemHedge.asian_fixing_start_date = prepDate(
        this.newEditedItemHedge.asian_fixing_start_date,
      );
      this.newEditedItemHedge.hedged_date = prepDate(
        this.newEditedItemHedge.hedged_date,
      );
      this.newEditedItemHedge.sale_date = prepDate(
        this.newEditedItemHedge.sale_date,
      );
      this.newEditedItemHedge.shipping_date = prepDate(
        this.newEditedItemHedge.shipping_date,
      );
    },
    // ===== events =====
    onUserCancel() {
      this.$emit("eventOnUserCancel");
    },
    onUserNotionalChange(val) {
      this.newEditedItemHedge.notional = Math.max(1, val);
    },
    onUserPremiumChange(val) {
      this.newEditedItemHedge.premium = val;
    },
    validateBeforeSubmit() {
      if (this.fixingValueDistance <= 0 && this.fixingValueDistance >= -15) {
        this.$validator.validateAll().then((result) => {
          if (result) {
            if (
              JSON.parse(JSON.stringify(this.editedItemHedge)) ===
                JSON.parse(JSON.stringify(this.newEditedItemHedge)) &&
              this.createEditTextExpoCommodities === "Edit Hedge"
            ) {
              this.$emit("eventOnUserCancel");
            } else {
              this.newEditedItemHedge.edited = true;
              this.$emit(
                "eventOnValidateBeforeSubmit",
                this.newEditedItemHedge,
              );
            }
          }
        });
      }
    },
    onCrudHedgeCurrency(event) {
      let idx = event.target.options.selectedIndex;
      let item = this.allCurrencies[idx].currency_name;
      this.leftRightCurrHedge = [item.slice(0, 3), item.slice(3, 6)];
      this.newEditedItemHedge.fk_idcountry_currency = item.slice(0, 3);
      this.newEditedItemHedge.fk_idcountry_premium_currency = item.slice(3, 6);
    },
  },
};
</script>
